import $ from "jquery";
import "bootstrap3";
import "jquery-bootstrap-wizard";
import "jquery-ui";
import "slick-carousel";


$("#testimonialCarousel").slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: true,
      },
    },
  ],
});

$("#prevArrow").on("click", function() {
  $("#testimonialCarousel").slick("slickPrev");
});

$("#nextArrow").on("click", function() {
  $("#testimonialCarousel").slick("slickNext");
});

$(".sidebar__item--blue").on("click", function() {
  $(this).toggleClass("sidebar__item--green");
});

$(".sidebar__item--dropdown").on("click", function() {
  $(this)
    .toggleClass("sidebar__item--active")
    .find(".sidebar__link")
    .toggleClass("sidebar__link--active");
});

if ($(".page-template-page-location").length) {
  $(document).on("click", "#nf-field-4", function() {
    ga("send", "event", {
      eventCategory: "How Can We Help (Submit Button)",
      eventAction: "Submit Button",
      eventLabel: "How Can We Help (Submit Button)",
      eventValue: 1.0,
    });
  });
}

if ($(".page-template-page-contact").length) {
  $(document).on("click", "#nf-field-4", function() {
    ga("send", "event", {
      eventCategory: "Contact Form (Submit)",
      eventAction: "Submit Button Click",
      eventLabel: "Contact Form (Submit)",
      eventValue: 1.0,
    });
  });
}
/* ========================================= */
/* ========================================= */
/* ========================================= */
/* ========================================= */
$(".search-icon").on("click", function() {
  $(this).toggleClass("search-icon--active");
  $('.search-bar__input').toggleClass('search-bar__input--open');
});



// WEBPACK FOOTER //
// ./js/app.js